<template>
	<!-- <v-container fluid> -->
		<v-dialog v-model="dialog" width="650" >
			
			<v-card outlined style="overflow-x:hidden;">
				<v-card-title 
					v-text="$ml.get('data')" 
					class="justify-center pa-0 body-1 primary"
				></v-card-title>
				<v-divider></v-divider>
				<v-card-text class = "pa-1">
					
					<v-row >
						<v-col md="6">
							<!-- class="d-flex col-md-7" -->
							<v-card 
								height = "100%"
								class  = "elevation-1"
							>
								<v-card-text outlined class = "pa-0 ">
									<!-- float-left  -->
									<v-row
										no-gutters

									>
										<v-col
											cols = "6"
										>
											
											
											<v-card 
												outlined
												class 	= "pa-1" 
												height  = "100%"
											>
												<v-img 
													:src="item.thumbnail" 
													@error="item.thumbnail = '/img/no_img_found.png'"
													width="100%" 
												></v-img>
												<v-divider></v-divider>
												<!-- v-card-subtitle -->
												<p 
													style = "line-height: 100%"
													class = "pa-0 ma-0" 
													v-text="$ml.get('img')" 
												></p>
											</v-card>
										</v-col>
										<v-col
											cols   = "6"											
										>
											
											<!-- float-right  -->
											<v-card  
												outlined
												class 	= "pa-1" 
												height  = "100%"
											>
												<v-img 
													:src="item.trained_thumbnail" 
													@error="item.trained_thumbnail = '/img/no_img_found.png'"
													width="100%"
												></v-img>
												<v-divider></v-divider>
												<!-- v-card-subtitle -->
												<p 
													style = "line-height: 100%"
													class = "pa-0 ma-0" 
													v-text="$ml.get('trained_thumbnail')" 
												></p>
													<!-- class="pa-0 caption text-center" -->
											</v-card>
										</v-col>
										<v-col
											cols = "12"
										>
											
											<!-- float-right  -->
											<v-card  
												outlined
												class 	= "pa-1" 
												height  = "100%"
												v-show  = "item.full_img"
											>
												<v-img 
													:src   = "item.full_img" 
													@error = "item.full_img = '/img/no_img_found.png'"
													width="100%"
												></v-img>
												<v-divider></v-divider>												
											</v-card>
										</v-col>
									</v-row>
								</v-card-text>
							</v-card>
						</v-col>
						<v-col md="6"  class="pa-0 pt-0">
							<v-card-subtitle class="pl-0 pr-7 pt-1 pb-0">
								<v-simple-table dense>
									<template v-slot:default>
										<tbody>
											<tr>
												<th>
													{{$ml.get('id')}}:
												</th>
												<td>
													{{item.id_tracker}}
													<!-- <p style="font-size:80%;" class="pa-0 ma-0"> </p> -->
												</td>
											</tr>
											<tr>
												<th>
													{{$ml.get('device')}}:
												</th>
												<td>
											 		{{ item.device }}
												</td>
											</tr>
											<tr>
												<th>
													{{$ml.get('name')}}:
												</th>
												<td>
											 		{{item.prediction}}
												</td>
											</tr>
											<tr>
												<th>
													{{$ml.get('date')}}: 
												</th>
												<td style="font-size:80%">
													{{item.timestamp}}
												</td>
											</tr>
											<tr>
												<th>
													{{$ml.get('confidence')}}
												</th>
												<td>
													{{item.confidence}}
												</td>
											</tr>
											<tr>
												<th>
													{{$ml.get('number_detecteds')}}
												</th>
												<td>
													{{item.num_dets}}
												</td>
											</tr>
										</tbody>
									</template>							
								</v-simple-table>
							</v-card-subtitle>
						</v-col>
					</v-row>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn 
						small 
						color="error" 
						v-text="$ml.get('close')" 
						@click="dialog=false"
					></v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	<!-- </v-container> -->
</template>
<script>
	export default{
		name: 'show_data',
		props:['info_to_component'],
		data:()=>({
			dialog:false,
			item: {},
			info: {
				thumbnail 			: '/img/no_img_found.png',
				trained_thumbnail 	: '/img/no_img_found.png',
				// full_img 			: '/img/no_img_found.png',
				id_tracker 			: '',
				prediction 			: '',
				timestamp 			: '',
				confidence 			: '',
				num_dets  			: '',
			},
		}),
		watch:{
			info_to_component:function(v){
				console.log('open modal',v)
				if (v) {
					this.item = v;
					this.dialog = true;
				}
			}, // item
			dialog: function(val){
				if (!val) {
					this.item = this.info;
					this.$emit('close', {});
				}
			}, // dialog
		},
	}
</script>